import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-login-faq',
    templateUrl: './login-faq.component.html',
    styleUrls: ['./login-faq.component.scss'],
    standalone: false
})
export class LoginFaqComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
